import { render } from "./BaseFormGroup.vue?vue&type=template&id=476cc808"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js"
script.render = render

export default script